/**
 * External dependencies
 */
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Box, Text } from "@towersystems/towersystems-design-system";
import { noop } from "lodash";

/**
 * Internal dependencies
 */
import Button from "components/button";
import ButtonGroup from "components/button-group";
import FormFieldset from "components/forms/form-fieldset";
import FormLabel from "components/forms/form-label";
import { saveReport } from "state/reports/actions";
import { getReportId } from "state/ui/report-rename-form/selectors";
import useInput from "hooks/use-input";
import { getReport } from "state/reports/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const RenameReportForm = ({
  data = {},
  reportId,
  afterSave = noop,
  onCancel = noop,
  ...props
}) => {
  const { value, bind } = useInput("name", data.name);
  const [isSaving, setSaving] = useState(false);
  const nameInput = useRef(null);
  const isDisabled = isSaving || value.length <= 0;

  useEffect(() => {
    nameInput.current.focus();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await props.saveReport(reportId, { name: value });
      afterSave(reportId, { name: value });
    } catch (e) {}
    setSaving(false);
  };

  return (
    <form onSubmit={handleSave}>
      <Box padding="xlarge">
        <FormFieldset>
          <FormLabel htmlFor="name">
            <Text size="xsmall" weight="medium">
              View name
            </Text>
          </FormLabel>
          <input type="text" autoComplete="off" ref={nameInput} {...bind} />
        </FormFieldset>
      </Box>
      <Box paddingBottom="xlarge" paddingRight="xlarge" paddingLeft="xlarge">
        <ButtonGroup>
          <Button disabled={isDisabled} secondary borderless>
            Rename
          </Button>
          <Button onClick={() => onCancel()}>Cancel</Button>
        </ButtonGroup>
      </Box>
    </form>
  );
};

export default connect(
  (state) => {
    let reportId = getReportId(state);
    let report = getReport(state, reportId) || {};
    return {
      reportId,
      data: { name: report && report.name },
    };
  },
  { saveReport }
)(RenameReportForm);
